// extracted by mini-css-extract-plugin
export var swipe = "Swipeable-module--swipe--3rtoN";
export var slide = "Swipeable-module--slide--2L81f";
export var opacity = "Swipeable-module--opacity--3KTq5";
export var circles = "Swipeable-module--circles--1sqav";
export var circle = "Swipeable-module--circle--hOnic";
export var active = "Swipeable-module--active--3l6My";
export var img = "Swipeable-module--img--3FYPD";
export var label = "Swipeable-module--label--29tWO";
export var amount = "Swipeable-module--amount--3MAga";